import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../Redux/Actions/Theme";
import Button1 from "./Buttons/Button1";

const Home = () => {
  const dispatch = useDispatch();
  const { darkmode } = useSelector(({ ThemeReducer }) => ThemeReducer);

  return (
    <>
      <span onClick={() => dispatch(toggleTheme(!darkmode))}>
        <Button1 title="Toggle">Toggle</Button1>
      </span>
    </>
  );
};

export default Home;
